import Link from 'next/link';
import React from 'react';
import { FollowersIcon } from '../../svg/dashboard/FollowersIcon';
import { PointsIcon } from '../../svg/dashboard/PointsIcon';
import { ProfileViewsIcon } from '../../svg/dashboard/ProfileViewsIcon';
import { MessageIcon } from '../../svg/MessageIcon';
import { Stat } from './Stat';

type Props = {
    ctaUrl: string;
    ctaBtn: string;
    header: string;
    ctaDescrip: string;
    headColor: string;
    btnColor: string;
};

export const DashboardCta: React.FC<Props> = ({ ctaUrl, ctaBtn, header, ctaDescrip, headColor, btnColor }) => {
    return (
        <div className="dashboard-cta-card">
            <div className={`header ${headColor ? headColor : ''}`}>
                <h2 className="title">{header}</h2>
            </div>
            <div className="content">
                <p className="description">{ctaDescrip}</p>
                <Link href={ctaUrl}>
                    <a className={`button ${btnColor ? btnColor : ''}-button medium-button`} rel="noreferrer">
                        {ctaBtn}
                    </a>
                </Link>
            </div>
        </div>
    );
};
